import { Routes } from '@angular/router';

import { homeSegments } from '@advania-cosoftware/wolf-router';

export const homeRoutes: Routes = [
    {
        path: homeSegments.home,
        loadComponent: () => import('./pages/home-page/home.page').then((m) => m.HomePage),
    },
];
